import { RETURN_DISPOSAL_PROCESS_METHOD, type TypeReturnDisposalProcessMethod } from '~/constants';

import type {
  TypeReturnDisposalInfo,
  TypeReturnDisposalIssueApi,
  TypeReturnDisposalProcessStatus,
} from '~/types/receive.types';

/** [입고관리 > 회송/폐기 관리] 목록 조회 API 행 → 테이블 행 매퍼 (처리방법 코드→한글명) */
const transformReturnDisposalIssue = (issue: TypeReturnDisposalIssueApi): TypeReturnDisposalInfo => ({
  inspectionId: issue.inspectionId,
  receiveRequestCode: issue.purchaseOrderCode,
  issueCenterName: issue.issuedWarehouseName,
  issuedAt: issue.issueRegisteredAt,
  elapsedDays: issue.elapsedDays,
  processMethodCode: issue.inspectionProcessMethod as TypeReturnDisposalProcessMethod,
  processMethodName:
    RETURN_DISPOSAL_PROCESS_METHOD[issue.inspectionProcessMethod as TypeReturnDisposalProcessMethod] ??
    issue.inspectionProcessMethod,
  processStatus: issue.inspectionProcessStatus as TypeReturnDisposalProcessStatus,
  productCode: issue.goodsCode,
  productName: issue.goodsName,
  issueType: issue.issueType,
  issueUnit: issue.defectQty,
  scrapPlannedAt: issue.scrapPlannedAt,
  rtsPlannedAt: issue.rtsPlannedAt,
  isKurlyNowCenter: issue.isKurlyNowCenter,
  cluster: issue.cluster,
});

export default transformReturnDisposalIssue;
